// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { ComplianceService } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Service/Compliance';
import { InstrumentConfiguration } from '@daml.js/dtc-registry/lib/Dtc/Registry/V3/Configuration/Instrument';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';

const useRemoveComplianceLockInstrumentConfiguration: () => UseMutationResult<
  void,
  string,
  {
    complianceServiceCid: ContractId<ComplianceService>;
    instrumentConfigurationCid: ContractId<InstrumentConfiguration>;
  }
> = () => {
  const ledgerApi = useLedgerApiClient();

  return useMutation({
    mutationKey: ['removeComplianceLockInstrumentConfiguration', ledgerApi],
    mutationFn: async ({ complianceServiceCid, instrumentConfigurationCid }) => {
      return ledgerApi.removeComplianceLockOnRegistryInstrumentConfiguration(
        complianceServiceCid,
        instrumentConfigurationCid,
      );
    },
    retry: false,
  });
};

export default useRemoveComplianceLockInstrumentConfiguration;
